.accessibility-button__container {
  position: fixed;
  width: 100%;
  line-height: 0px;
  z-index: 55; // For some usecases we should be able to hide it
}
